import http from '@http';

class UserGroupService {
    groups(placeId) {
        return http.get(`/api/places/${placeId}/user-groups/`).then((res) => res.data);
    }

    store(placeId, data) {
        return http.post(`/api/places/${placeId}/user-groups`, data).then((res) => res.data);
    }

    update(placeId, groupId, data) {
        return http.put(`/api/places/${placeId}/user-groups/${groupId}`, data).then((res) => res.data);
    }

    delete(placeId, groupId) {
        return http.delete(`/api/places/${placeId}/user-groups/${groupId}`).then((res) => res.data);
    }

    toggleState(placeId, groupId) {
        return http.put(`/api/places/${placeId}/user-groups/${groupId}/toggle-state`).then((res) => res.data);
    }
}

export default new UserGroupService();
